module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_3.ac64cccc.svg";